/* eslint-disable */
import { CONFIG } from "~/config";
import { node } from "~/util/dom";
import { getMapsetById } from "~/util/mapset";
import SettingsMapset from "~/profile/settings/mapsets/mapset";
import { _ } from "~/i18n";

interface ISettingsMapsetsProps {
	selectedId: number;
	onChange: (id: number, seo: string) => void;
}

export default class SettingsMapsets {
	#container: HTMLDivElement;
	#mapsets: Array<SettingsMapset>;

	constructor({
		selectedId,
		onChange,
	}: ISettingsMapsetsProps) {
		this.#container = node("div", { className: "settings-mapsets" });
		this.#mapsets = [];

		// nadpis
		const title = node("h3", { className: "settings-mapsets__title", innerHTML: _("profile.settings.mapsets.default") });
		this.#container.appendChild(title);
		// seznam mapsetu
		const list = node("ul", { className: "settings-mapsets__list" });
		this.#container.appendChild(list);

		// dummy mapset pro posledni mapset
		const lastMapset = {
			...CONFIG.mapsets[0],
			id: 0,
			name: _("profile.settings.mapsets.lastused"),
			seo: "posledni",
			icon_url: "/img/mapset/lastmapset.svg",
		};
		const mapset = new SettingsMapset({
			mapset: lastMapset,
			selected: selectedId === 0,
			onClick: () => {
				this.#mapsets.forEach((mapset, index) => { mapset.selected = index === 0; });
				onChange(lastMapset.id, lastMapset.seo);
			},
		});

		list.appendChild(mapset.container);
		this.#mapsets.push(mapset);

		CONFIG.mapsetsIDsMenuList.forEach(mapsetId => {
			const mapsetData = getMapsetById(mapsetId);
			const mapset = new SettingsMapset({
				mapset: mapsetData,
				selected: selectedId === mapsetId,
				onClick: () => {
					this.#mapsets.forEach(mapset => { mapset.selected = mapset.mapset.id === mapsetId; });
					onChange(mapsetData.id, mapsetData.seo);
				},
			});

			list.appendChild(mapset.container);
			this.#mapsets.push(mapset);
		});
	}

	destroy() {
		this.#mapsets.forEach(mapset => mapset.destroy());
		this.#mapsets = [];
	}

	get container() {
		return this.#container;
	}
};
